// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610051605/js/" + chunkId + "." + {"44":"97f31957","225":"118cb5cb","481":"b442166f","486":"fd15dd01","770":"3ed6200e"}[chunkId] + ".0.1433676673549542.chunk.js";
};